import { useAppDispatch, useAppSelector } from '~/store/hooks'
import { duplicateSelectedObjects } from '~/store/selectedObjects'
import { Button } from '~/ui/Button'
import { Icon } from '~/ui/Icon'

export const DuplicateSelectedObjectsButton = () => {
  const isDisabled = useAppSelector(state => !state.selectedObjects.length)
  const dispatch = useAppDispatch()
  return (
    <Button variant="toolbelt" isDisabled={isDisabled} onPress={() => dispatch(duplicateSelectedObjects())}>
      <Icon name="duplicate" />
      Copy
    </Button>
  )
}
